module.exports = __webpack_public_path__ + "media/images/rounded-hexagon-d06c029393fed206931352d962c06c5e.svg";